import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, resolveImg } from "@/lib/api";
import { Reveal } from "@/components/site/Reveal";
import { PageHero } from "@/components/site/PageHero";
import { Seo } from "@/components/site/Seo";

export default function Conditions() {
  const [concerns, setConcerns] = useState([]);
  useEffect(() => {
    api.get("/concerns").then((r) => setConcerns(r.data)).catch(() => {});
  }, []);

  return (
    <div>
      <Seo title="Where Do You Need Relief? Conditions We Help | Psalm 30:2 Chiropractic Gardner KS" description="Back pain, neck pain, hip and knee pain, headaches, sciatica, sports injuries, pregnancy discomfort and more in Gardner, Kansas." />
      <PageHero
        eyebrow="Concern-Based Care"
        title="Where do you need relief?"
        intro="Pain is one of the ways your nervous system tells you something in the chain needs attention. Start with what you're experiencing, and we'll connect it to relevant assessment and treatment options — never as a guaranteed diagnosis."
      />
      <section className="bg-ivory pb-28 px-6 md:px-10 lg:px-14" data-testid="conditions-grid">
        <div className="max-w-[1500px] mx-auto grid sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-12">
          {concerns.map((c, i) => (
            <Reveal key={c.slug} delay={(i % 3) * 60}>
              <Link to={`/conditions/${c.slug}`} className="group block" data-testid={`condition-card-${c.slug}`}>
                <div className="overflow-hidden rounded-sm aspect-[4/3] mb-5">
                  <img src={resolveImg(c.image)} alt={c.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-1000" loading="lazy" />
                </div>
                <h3 className="font-serif text-2xl lg:text-3xl text-espresso group-hover:text-taupe transition-colors">{c.name}</h3>
                <p className="mt-2 text-espressosoft/70 font-light leading-relaxed">{c.summary}</p>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
